<div class="battery-level" *ngIf="batteryState !== EAssetBatteryState.Missing">
    <span *ngIf="!showBatteryPercentageOnRightSide && !isPrivacyModeEnabled"
      class="battery-level__percentage"
      [class.battery-level__percentage--white]="isTooltip">{{ truncatedBatteryPercentage }}%</span>
    <span class="battery-level__progress-bar-container" [class.battery-level__progress-bar-container--white]="isTooltip">
      <mat-progress-bar class="progress-bar"
        [class.progress-bar--low-level]="batteryState === EAssetBatteryState.Low"
        [class.progress-bar--charging]="isCharging"
        [class.progress-bar--stale]="isBatteryInfoStale || isPrivacyModeEnabled"
        [class.progress-bar--black]="isTooltip"
        fmTooltip="{{ formattedLastBatteryUpdate }}"
        [shouldDisplayFmTooltip]="shouldDisplayTooltip"
        mode="determinate"
        [value]="truncatedBatteryPercentage"></mat-progress-bar>
    </span>
    <div class="progress-bar__battery-head" [class.progress-bar__battery-head--white]="isTooltip"></div>
    <mat-icon *ngIf="isCharging && !isTooltip && !isPrivacyModeEnabled" 
      svgIcon="ic-bolt"
      class="mat-icon-size-xs battery-level__charging"
      [class.battery-level__charging--balloon]="showBatteryPercentageOnRightSide"
      fmTooltip="{{ formattedLastBatteryUpdate }}"
      [shouldDisplayFmTooltip]="shouldDisplayTooltip"></mat-icon>
    <mat-icon *ngIf="isCharging && isTooltip" 
      svgIcon="ic-replay-segment-bolt"
      class="mat-icon-size-xs battery-level__charging"></mat-icon>  
    <span *ngIf="showBatteryPercentageOnRightSide && !isPrivacyModeEnabled" 
      class="battery-level__percentage--balloon">{{ truncatedBatteryPercentage }}%</span>
    <span *ngIf="isBatteryInfoStale && showBatteryPercentageOnRightSide"
      class="battery-level__stale-info">{{ formattedLastBatteryUpdate }}</span>
</div>